// extracted by mini-css-extract-plugin
export var divider = "_j4-7";
export var itemsToggle = "_j4-8";
export var mergeModal = "_j4-1";
export var optionCard = "_j4-4";
export var radioGroup = "_j4-6";
export var radioOption = "_j4-0";
export var selected = "_j4-5";
export var shipmentOptions = "_j4-2";
export var tableOptions = "_j4-3";